import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/hair-color-changer"
    exact
    path="/consumer/features/hair-color-changer"
    component={AsyncPage}
  />,
];
